import React, { FC } from 'react';
import { View } from 'react-native';
import BlockWrapper from '@v2/pages/machines/modules/now/components/Overview/components/BlockWrapper';
import { MACHINES_NOW_OVERVIEW_BLOCK_CONFIG, TOP_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { scale } from '@components/frame';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import TouchableElement from '@components/common/touchableElement';
import TopBlockHeader from './components/TopBlockHeader';
import TopBlockSeparator from './components/TopBlockSeparator';
import TopBlockImages from './components/TopBlockImages';
import { BaseTopBlockProps, NCFileNameProp, OnTopBlockImagePressProp, OnTopBlockPressProp } from './types';

interface LinkedOrUnknownNCFileTopBlockProps extends BaseTopBlockProps, OnTopBlockImagePressProp, OnTopBlockPressProp, Partial<NCFileNameProp> {}

const LinkedOrUnknownNCFileTopBlock: FC<LinkedOrUnknownNCFileTopBlockProps> = ({ C, onTopBlockPress, onTopBlockImagePress, ncFileName }) => {
  const { blockBgColor, paddingHorizontal } = MACHINES_NOW_OVERVIEW_BLOCK_CONFIG;
  const { gapBetweenInfoLines, paddingVertical } = TOP_BLOCK_CONFIG;

  return (
    <BlockWrapper testID={TEST_IDS.liveScreen.topBlockLinkedUnknown} containerStyle={{ flex: 1, paddingHorizontal: 0 }}>
      <TouchableElement testID={TEST_IDS.liveScreen.topBlockLinkedUnknownHeader} onPress={onTopBlockPress}>
        {({ boxStyle, pressHoverColor }) => (
          <View
            style={[
              onTopBlockPress && boxStyle,
              {
                backgroundColor: onTopBlockPress ? C(pressHoverColor(blockBgColor)) : C(blockBgColor),
                paddingVertical: scale(paddingVertical),
                gap: scale(gapBetweenInfoLines),
                paddingHorizontal: scale(paddingHorizontal),
                borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
                borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
              },
            ]}
          >
            <TopBlockHeader C={C} ncFileName={ncFileName} showActionArrow gapCompensation={gapBetweenInfoLines} />
          </View>
        )}
      </TouchableElement>

      <TopBlockSeparator C={C} />

      <TopBlockImages onTopBlockImagePress={onTopBlockImagePress} />
    </BlockWrapper>
  );
};

export default LinkedOrUnknownNCFileTopBlock;
